import {useEffect, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Skeleton} from '@mui/material';
import {Stack} from '@mui/material';

am4core.useTheme(am4themes_animated);
am4core.options.autoSetClassName = true;
am4core.options.minPolylineStep = 5;

const ChartSeven = ({data, name, className}) => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);
        chart.defaultState.transitionDuration = 0;
        chart.hiddenState.transitionDuration = 0;

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        // Add data
        chart.data = chart.data = chart.data = data['data'].sort((a, b) =>
            a.tax_revenue_weight - b.tax_revenue_weight
        );
        let legend = data['legend'];

        const colors = [
            am4core.color("#D64ECF"),
            am4core.color("#45CB85"),
            am4core.color("#0081A7"),
            am4core.color("#FFA500"),
        ];

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "gov_entity";
        categoryAxis.renderer.minGridDistance = 15;
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.labels.template.rotation = -90;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";


        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.min = 0;
        valueAxis.max = 100;
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.inside = false;
        valueAxis.renderer.labels.template.adapter.add("text", function(text) {
            return text + " %";
        });

        createSeries("tax_revenue_weight", legend['tax_revenue_weight'], colors[0]);
        createSeries("non_tax_revenue_weight", legend['non_tax_revenue_weight'], colors[1]);

        // Create series
        function createSeries(field, name, color) {
            // Set up series
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.name = name;
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "gov_entity";
            series.sequencedInterpolation = true;
            series.tooltip.pointerOrientation = "horizontal";
            series.fill = color;
            series.stroke = color;

            // Make it stacked
            series.stacked = true;

            // Configure columns
            series.columns.template.width = am4core.percent(60);
            series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

            // Add label
            let label = series.bullets.push(new am4charts.LabelBullet());
            label.label.text = "{valueY}%";
            label.locationY = 0.5;
            label.label.hideOversized = false;
            label.label.rotation = 270;
            label.label.truncate = false;

            return series;
        }

        // Legend
        chart.legend = new am4charts.Legend();

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.menu.align = 'left';
        chart.exporting.menu.verticalAlign = 'top';

    }, []);

    return (
        <>
            <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            {showLoader && (
                <Stack spacing={1}>
                    <Skeleton variant='text'/>
                    <Skeleton variant='rounded' width={'auto'} height={500}/>
                </Stack>
            )}
        </>
    );
};

export default ChartSeven;
